import { getElem, pause } from "../utils";

class HTML_Tutorial {
    private html = {
        tutorial: getElem("tutorial"),
        skip: getElem("tutorial-skip"),
        play: getElem("tutorial-playGame"),
        container: getElem("tutorial-container"),
        growl: getElem("tutorial-growl"),
        roar: getElem("tutorial-roar"),
        text: getElem("tutorial-text"),
        lion: {
            textTimeFor: getElem("tutorial-lionTimeForText"),
            textReady: getElem("tutorial-lionReadyText"),
        }
    };

    private subText = {
        growl_sub: getElem("growl-sub"),
        roar_sub1: getElem("roar-sub1"),
        roar_sub2: getElem("roar-sub2"),
    }

    constructor() {
        this.html.tutorial.style.display = "none";
    }
    
    public async activate(index: number) {
        if(index === 0) {
            this.html.skip.style.right = "10px";
            this.html.tutorial.style.display = "flex";
            this.html.growl.style.display = "flex";
            this.html.text.innerHTML = "To make the Lion walk";
            await pause(500);
            
            this.html.lion.textTimeFor.style.scale = '1';
            this.html.lion.textTimeFor.style.left = '35%';
            this.html.lion.textTimeFor.style.opacity = '1';
            this.html.container.style.opacity = '1';
            this.html.growl.style.opacity = '1';
            this.html.growl.style.left = "0px";

            await pause(700);
            this.subText.growl_sub.style.scale = "1.5";
            this.subText.growl_sub.style.opacity = "0";
        } else if(index === 1) {
            this.html.roar.style.display = "flex";
            this.html.text.innerHTML = "To make the Lion jump";
            await pause(500);
            this.html.roar.style.opacity = '1';
            this.html.roar.style.left = "0px";
            await pause(700);
            this.subText.roar_sub1.style.scale = "2";
            this.subText.roar_sub1.style.opacity = "0";
            await pause(200);
            this.subText.roar_sub2.style.scale = "2";
            this.subText.roar_sub2.style.opacity = "0";
        } else if (index === 2) {
            this.html.lion.textReady.style.display = "block";
            this.html.play.style.display = "flex";
            this.html.text.innerHTML = "Tapping 'Play' will record<br>the experience to share<br>with friends!";
            await pause(200);
            this.html.play.style.opacity = '1';
            this.html.play.style.left = "0px";

            this.html.lion.textReady.style.scale = '1';
            this.html.lion.textReady.style.left = '35%';
            this.html.lion.textReady.style.opacity = '1';
        }
        this.html.text.style.opacity = "1";
        this.html.text.style.right = "0px";
    }

    public async deactivate(index: number) {
        this.html.text.style.right = "100%";
        this.html.text.style.opacity = "0";
        if(index === 0) {
            this.html.growl.style.left = "100%";
            this.html.growl.style.opacity = '0';
            await pause(500);
            this.html.growl.style.display = "none";
        } else if(index === 1) {
            this.html.roar.style.left = "100%";
            this.html.roar.style.opacity = '0';
            this.html.lion.textTimeFor.style.scale = '1.2';
            this.html.lion.textTimeFor.style.left = '100%';
            this.html.lion.textTimeFor.style.opacity = '0';
            
            await pause(500);
            this.html.roar.style.display = "none";
            this.html.lion.textTimeFor.style.display = 'none';
        } else if(index === 2) {
            this.html.lion.textReady.style.scale = '1.2';
            this.html.lion.textReady.style.left = '100%';
            this.html.lion.textReady.style.opacity = '0';
        }
        this.html.text.style.right = "-100%";
    }

    public async hideSkip() {
        this.html.skip.style.right = "";
    }

    public async hide() {
        this.html.skip.style.right = "";
        this.html.container.style.opacity = '0';
        await pause(500);
        this.html.tutorial.style.display = "none";
    }
}

export default HTML_Tutorial;